import React from "react";
import { Typography, Grid, Dialog, Paper, DialogContent, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ReactComponent as SmLogo } from "../Common/Logo/smLogo.svg";

const sxStyles = {
    logo: {
        maxWidth: { xs: 58, sm: 86, md: 130 },
        maxHeight: { xs: 28, sm: 30, md: 30 },
        mt: 0.25,
        mr: { xs: 0.25, sm: 1.25, md: 2.5 },
        flexGrow: 1,
    },
};

export default function PurchaseComplete({ open, stripeOrders, onClose }) {
    if (open && stripeOrders && stripeOrders.length > 0) {
        return (
            <Dialog 
                onClose={onClose}
                open={open}
            >
                <Paper elevation={3} sx={{ p: 2.5, width: "100%", height: "100%" }}>
                    <DialogContent sx={{ width: "100%", height: "100%", overflow: "hidden" }}>
                        <Grid spacing={1} container direction="column" justifyContent="flex-start" alignItems="flex-start" sx={{ width: "100%", height: "100%", flexWrap: "nowrap" }}>
                            <Grid item sx={{ width: "100%" }}>
                                <Grid container direction="row" justifyContent="flex-end" alignItems="flex-start">
                                    <Grid item sx={{ flexGrow: 1 }}>
                                        <SmLogo sx={sxStyles.logo} />
                                    </Grid>
                                    <Grid item>
                                        <IconButton 
                                            onClick={onClose}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                                <Grid item>
                                    <CheckCircleIcon fontSize="large" sx={{ color: "#1dcf4c" }} />
                                </Grid>

                                <Grid item>
                                    <Typography>
                                        {stripeOrders[0].invoiceType === "subscription_create" ? "Subscription Created" :  stripeOrders[0].invoiceType === "subscription_cycle" ?  "Subscription Coins Added" : "Purchase Complete"}
                                    </Typography>
                                </Grid>
                                {stripeOrders.map((item, index) => {
                                    if(item.invoiceType === "subscription_create"){
                                        return (
                                            <>
                                                <Grid item>
                                                    <Grid spacing={1} container direction="column" justifyContent="center" alignItems="flex-start">
                                                        <Grid item>
                                                            <Typography>
                                                                {"Payment Reference : " + item.id}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Typography>
                                                                {item.value + " Coins have been added to your account"}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        )
                                    }
                                    else if(item.invoiceType === "subscription_cycle"){
                                        return (
                                            <>
                                                <Grid item>
                                                    <Grid spacing={1} container direction="column" justifyContent="center" alignItems="flex-start">
                                                        <Grid item>
                                                            <Typography>
                                                                {"Payment Reference : " + item.id}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Typography>
                                                                {"Your monthly " + item.value + " Coins have been added to your account"}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        )
                                    }
                                    else{
                                        return (
                                            <>
                                                <Grid item>
                                                    <Grid spacing={1} container direction="column" justifyContent="center" alignItems="flex-start">
                                                        <Grid item>
                                                            <Typography>
                                                                {"Payment Reference : " + item.id}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Typography>
                                                                {item.value + " Coins have been added to your account"}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        )
                                    }
                                })}
                                {stripeOrders[0].invoiceType === "subscription_create" && (
                                    <Grid item>
                                        <Typography>
                                            {"This subscription will be charged montly.  You can change/cancel your subscription or manage your payment details via the 'Manage Billing' option in the top right menu toolbar."}
                                        </Typography>
                                    </Grid>
                                )}
                                {stripeOrders[0].invoiceType === "subscription_cycle" && (
                                    <Grid item>
                                        <Typography>
                                            {"To updated your change your subscription, you can manage your payment details via the 'Manage Billing' option in the top right menu toolbar."}
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Paper>
            </Dialog>
        );
    }

    return null;
}